import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import("@/views/layouts/MainLayout.vue"),
    name: "Main",
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/pages/HomePage.vue"),
      },
      {
        path: "/departments",
        name: "Departments",
        component: () => import("@/views/pages/DepartmentPage.vue"),
      },
      {
        path: "/admissions",
        name: "Admissions",
        component: () => import("@/views/pages/AdmissionsPage.vue"),
      },
      {
        path: "/apply",
        name: "Application Form",
        component: () => import("@/views/pages/ApplicationForm.vue"),
      },
      {
        path: "/programmes",
        name: "Programmes",
        component: () => import("@/views/pages/ProgrammePage.vue"),
      },
      {
        path: "/blogs",
        name: "Blogs",
        component: () => import("@/views/pages/BlogsPage.vue"),
      },
      {
        path: "/about-us",
        name: "About Us",
        component: () => import("@/views/pages/AboutPage.vue"),
      },
      {
        path: "/blog-details/:id",
        name: "Blog Details",
        component: () => import("@/views/pages/BlogDetails.vue"),
      },
      {
        path: "/contact",
        name: "Contact Us",
        component: () => import("@/views/pages/ContactPage.vue"),
      },
      {
        path: "/gallery",
        name: "Gallery",
        component: () => import("@/views/pages/GalleryPage.vue"),
      },
      {
        path: "/:catchAll(.*)",
        name: "Not Found",
        component: () => import("@/views/layouts/NotFound.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
